import React, { useState } from 'react';
import clsx from 'clsx';
import I18n from 'i18n-js';
import cn from '@/utils/cn';
import Icon from '@/components/ui/Icon';
import Drawer from '@/components/common/Drawer';
import {
  useSlideReferenceMaterials,
} from '@/components/admin/SlideReferenceMaterialsDropdown/SlideReferenceMaterialsDropdown.utils';
import AsyncAssignmentModal from '@/components/staffer/AssignmentModal/AsyncAssignmentModal';
import { useModalManager } from '@/components/common/Modal';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import styles from '../Slide.module.scss';
import ReferenceMaterialCard from './ReferenceMaterialCard';

interface ReferenceMaterialsDrawerProps {
  offset?: boolean;
  slideId: number;
}

const ReferenceMaterialsDrawer = ({ offset = false, slideId }: ReferenceMaterialsDrawerProps) => {
  const lessonId = parseInt(useSlideShowContext(state => state.lessonId)?.toString(), 10);
  const programId = useSlideShowContext(state => state.programId);
  const userType = useSlideShowContext(state => state.userType);
  const userId = useSlideShowContext(state => state.userId);
  const isStaffer = userType !== 'Student';
  const { data: referenceMaterials, refetch: refetchSlideReferenceMaterials } = useSlideReferenceMaterials(slideId, lessonId);
  const modalManager = useModalManager();
  const [assignmentModalValues, setAssignmentModalValues] = useState({});

  if (referenceMaterials.length === 0) return null;

  return (
    <Drawer
      buttonClass={cn(
        'tw-flex tw-items-center tw-justify-center tw-absolute tw-right-0 tw-w-[35px] tw-h-[35px]',
        'tw-border-none tw-rounded-l tw-bg-teal-blue tw-cursor-pointer tw-z-10',
        { 'tw-top-0': !offset, 'tw-top-10': offset },
      )}
      buttonText={<Icon className="tw-cursor-pointer" fill="#fff" icon="Reading" />}
      contentClass={styles.teacherNotesContent}
      drawerClass={clsx(styles.teacherNotesDrawer, 'fr-view !tw-w-[300px] tw-text-xs')}
      headerClass={cn(styles.teacherNotesHeader, 'tw-bg-teal-blue tw-flex tw-items-center')}
      position="right"
      title={I18n.t('dive_deeper_with')}
    >
      <div>
        <p className="!tw-text-xs !tw-mb-4 tw-mt-2">{I18n.t('deepen_understanding')}</p>
        <div>
          {referenceMaterials.map(referenceMaterial => (
            <ReferenceMaterialCard
              key={`reference-material-${referenceMaterial.id}`}
              modalManager={modalManager}
              referenceMaterial={referenceMaterial}
              setAssignmentModalValues={setAssignmentModalValues}
            />
          ))}
        </div>
      </div>

      {lessonId && isStaffer && (
        <AsyncAssignmentModal
          closeModal={modalManager.close}
          handlePostSave={refetchSlideReferenceMaterials}
          initialLessonId={lessonId}
          initialValues={assignmentModalValues}
          modalIsOpen={modalManager.isOpen}
          programId={programId}
          stafferId={userId}
        />
      )}
    </Drawer>
  );
};

export default ReferenceMaterialsDrawer;
